import { ActionType, MutationSetManualRoundUpsArgs, PageName } from 'generated/types'
import { sendToSentry } from 'utils/errors'
import { FlowRoute } from 'utils/FlowProvider/types'
import { getGeneralError } from 'utils/getGeneralError'

import { RoundupsInvestedPrompt } from './roundupsInvestedPrompt'

export const handleSubmit = ({
  closeErrorModal,
  options,
  promptUser,
  isDynamicFunnelEnabled,
  route,
  routeToPage,
  showErrorModal,
  setManualRoundups,
  trackRoundUpsPastButtonTapped,
}) => async () => {
  trackRoundUpsPastButtonTapped()
  try {
    const roundUpIds = options?.filter(option => option !== undefined)

    const input: MutationSetManualRoundUpsArgs = {
      roundUpIds,
    }

    await setManualRoundups({ variables: input })
    await promptUser(RoundupsInvestedPrompt)

    isDynamicFunnelEnabled
      ? routeToPage(PageName.RoundUpsPast, ActionType.Continue)
      : route({ from: FlowRoute.RoundUpsPast, action: 'continue' })
  } catch (error) {
    const retryHandler = () => {
      closeErrorModal()
    }
    const { title, message, actions, image } = getGeneralError(
      error,
      { closeErrorModal },
      retryHandler,
    )
    showErrorModal({ title, message, actions, image })
    sendToSentry(error)
  }
}
